var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPanelEdge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 13 13",
    style: {
      enableBackground: "new 0 0 13 13"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;opacity:0.75;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.7,12.8c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.2-0.4,0-0.6L11.9,0.6c0.2-0.2,0.4-0.2,0.6,0c0.2,0.2,0.2,0.4,0,0.6L1,12.7 C1,12.8,0.9,12.8,0.7,12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6,12.6c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.2-0.4,0-0.6l5.6-5.6c0.2-0.2,0.4-0.2,0.6,0c0.2,0.2,0.2,0.4,0,0.6l-5.6,5.6 C6.8,12.6,6.7,12.6,6.6,12.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3,2.9c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l0.3-0.3c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4L12,2.6 C11.8,2.8,11.6,2.9,11.3,2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7,10.5c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l0.6-0.6c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4l-0.6,0.6 C4.2,10.4,3.9,10.5,3.7,10.5z M6.2,7.9C6,7.9,5.7,7.9,5.5,7.7c-0.4-0.4-0.4-1,0-1.4l0.6-0.6c0.4-0.4,1-0.4,1.4,0 c0.4,0.4,0.4,1,0,1.4L6.9,7.7C6.7,7.9,6.5,7.9,6.2,7.9z M8.8,5.4c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l0.6-0.6 c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4L9.5,5.1C9.3,5.3,9,5.4,8.8,5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5,12.7c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l0.3-0.3c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4l-0.3,0.3 C2,12.6,1.7,12.7,1.5,12.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4,7.7c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4L12,5.7c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4l-0.3,0.3 C12.9,7.6,12.6,7.7,12.4,7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3,10.8c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l0.8-0.8c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4L10,10.5 C9.8,10.7,9.5,10.8,9.3,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7,13.4c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l0.3-0.3c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4l-0.3,0.3 C7.2,13.3,6.9,13.4,6.7,13.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelEdge);
export default __webpack_public_path__ + "static/media/panel-edge.013bf1993b87e07d161a406631e28069.svg";
export { ForwardRef as ReactComponent };